module.exports = __webpack_public_path__ + "PTMETTAabout-4.c9ba35ea.png";